module.exports = __webpack_public_path__ + "img/professional.05f55dff.png";